import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { MdClose } from 'react-icons/md';
import * as Cookies from 'js-cookie';
import isEmpty from 'lodash/isEmpty';
import { AuthContext } from 'context/AuthProvider';
import Modal from 'components/UI/Antd/Modal/Modal';
import Button from 'components/UI/Antd/Button/Button';
import { ModalBody, ModalContent, ImageWrapper } from './MemberModal.style';
import temCard from 'assets/images/tem-logo.png';

const MemberModal = ({
  onOpenRequestDrawer,
  onOpenConnectDrawer,
  isRequestFlowContinue,
  isConnectFlowContinue,
  isReservationFlowContinue,
  location,
  match,
  history,
  showTemModal,
  className = ''
}) => {
  const { t } = useTranslation();
  const { loggedIn, user, waitingForAuth } = useContext(AuthContext);

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const init = () => {
      if (loggedIn && !isEmpty(user)) {
        setVisible(false);
        const { vessels } = user;
        const membershipDenied = Boolean(
          Cookies.get(`${encodeURIComponent(user.email)}_membership_denied`)
        );
        const allMemberships = [].concat.apply(
          [],
          vessels.map(({ memberships }) => memberships || [])
        );
        const allMembershipRequests = [].concat.apply(
          [],
          vessels
            .filter(v => !allMemberships.some(ms => ms.vessel_id === v.id))
            .map(({ membership_requests }) => membership_requests || [])
        );
        const isPending = allMembershipRequests.some(
          req => req.status === 'PENDING'
        );
        const connectedMemberships = Boolean(allMemberships.length);
        if (
          showTemModal &&
          !membershipDenied &&
          !connectedMemberships &&
          !isPending &&
          !isRequestFlowContinue &&
          !isConnectFlowContinue &&
          !isReservationFlowContinue
        ) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      } else {
        setVisible(false);
        const guestMembershipDenied = Boolean(
          Cookies.get('guest_membership_denied')
        );
        if (
          showTemModal &&
          !guestMembershipDenied
        ) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      }
    };
    if (!waitingForAuth) {
      init();
    }
  }, [
    loggedIn,
    user,
    isRequestFlowContinue,
    isConnectFlowContinue,
    location,
    waitingForAuth,
    showTemModal
  ]);

  const onClose = () => {
    setVisible(false);
    history.replace({
      pathname: `/${match.params.locale}`,
      search: ''
    });
  };

  const onRequest = () => {
    onClose();
    onOpenRequestDrawer();
  };

  const onConnect = e => {
    e.preventDefault();
    onClose();
    onOpenConnectDrawer();
  };

  const onDeny = () => {
    if (loggedIn && user) {
      Cookies.set(`${encodeURIComponent(user.email)}_membership_denied`, true, {
        expires: 365 * 10
      });
    } else {
      Cookies.set(`guest_membership_denied`, true, { expires: 365 * 10 });
    }
    onClose();
  };

  if (navigator.userAgent === 'ReactSnap') {
    return <></>;
  }

  return (
    <Modal
      title={null}
      closeIcon={<MdClose size={24} color='#ffffff' />}
      visible={visible}
      bodyStyle={{ padding: 0 }}
      centered={true}
      onCancel={onClose}
      wrapClassName={`member-modal ${className}`}
      footer={null}
      width={756}
      zIndex={10001}
    >
      <ModalBody>
        <ModalContent className={isMobile ? 'blue is-mobile' : 'blue'}>
          <h2>{t('TEM_MEMBERSHIP_MODAL_TITLE')}</h2>
          <ImageWrapper>
            <img alt={'TEM card'} src={temCard} />
          </ImageWrapper>
          <p>
            {t('CONNECT_YOUR_MEMBERSHIP_CARD')}
            <Link to='#' onClick={onConnect}>
              {t('HERE')}
            </Link>
          </p>
        </ModalContent>
        <ModalContent className={isMobile ? 'white is-mobile' : 'white'}>
          <h3>{t('DONT_HAVE_DIGITAL_CARD_YET')}</h3>
          <Button className='request-button' onClick={onRequest}>
            {t('REQUEST_NOW')}
          </Button>
          <Button type='link' onClick={onDeny}>
            {t('NO_DONT_SHOW_THIS_AGAIN')}
          </Button>
        </ModalContent>
      </ModalBody>
    </Modal>
  );
};

export default withRouter(MemberModal);
